import { render, staticRenderFns } from "./AccountDataStep.vue?vue&type=template&id=21321909&scoped=true"
import script from "./AccountDataStep.vue?vue&type=script&lang=js"
export * from "./AccountDataStep.vue?vue&type=script&lang=js"
import style0 from "./AccountDataStep.vue?vue&type=style&index=0&id=21321909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21321909",
  null
  
)

export default component.exports